import React, {useCallback, useRef, useState, useReducer, useEffect} from 'react';
import KeepAlive from 'react-activation';
import {message} from 'antd';
import {SActionBtn, SDrawerOrModal, SLowcodeList, STableActions} from "shj-components";
import dayjs from "dayjs";
import {get} from 'lodash-es';
import {getAuth, getUser} from "shj-utils";

import {convertListToTree, filterSerchData} from '@/utils/common';
import {modalRemindWorkerOrderrFn} from '../formModels/remindWorkerOrder';
import {modalWorkerOrderBackFn} from '../formModels/workerOrderBack';
import {modalAddWorkOrderFn} from '../formModels/addWorkOrder';
import {modaleditDisposePersonFn} from '../formModels/editDisposePerson';
import CheckThePhone from "@/components/CheckThePhone";
import {AnewOpenWorkerOrder, PushIssueComment, WorkerOrderAccept} from "../components/popconfirmBtn";
import config from './config.json';
import {useNavigate} from "react-router-dom";
import {ModalAddMatterFn} from "@/pages/vip/formModels/addMatter.tsx";
import {addCallBackIssueFn} from "@/pages/vip/formModels/addCallBackIssue.tsx";
import {
  getCustomerSource, getTicketsChannelConfig,
  getTicketsExposureConfig,
  getTicketsInternalConfig,
  getTicketsIssueListPage
} from "@/services/customerServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import {useSetState} from "ahooks";
import {ModalAddMatterDom} from '../formModels/addMatter.tsx'
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import UrlConfig from "@/api/UrlConfigs.ts";
import {authDict} from "shj-utils/dist/esm/utils";

export function MatterList() {
  const navigate = useNavigate()
  const listRef = useRef<any>();
  const [dataLevel, setDataLevel] = useState<any>();
  const [exportLoading, setExportLoading] = useState(false);
  const [openMatterEditModal, setOpenMatterEditModal] = useState(false);
  const [chooseRecord, setChooseRecord] = useState<any>({});

  useEffect(() => {
    const user = getUser();
    const group = get(user, 'currentRoles[0].dataLevel');
    setDataLevel(group);
  }, []);

  const fetchList = (values: any) => {
    return new Promise( (resolve, reject) => {
      try {
        const {current, pageSize, query} = values;
        const newObj = {...filterSerchData({...query}, ['disposeDate', 'commentSendDate'])};
        const newObj_ = {...filterSerchData({...newObj}, ['createdTime'], ['StartWith', 'EndWith'])};
        if (newObj_['companyIds']) {
          newObj_['companyIds'] = newObj_['companyIds'].toString();
        }
        getTicketsIssueListPage({params: {pageId: current, pageSize}, data: {...newObj_}}).then(res=>{
          resolve(apiData2Table(res))
        })
      } catch (e) {
        reject({success: false});
      }
    });
  };

  // 获取筛选项
  const getSelection = () => {
    return new Promise((resolve, reject) => {
      Promise.all([
        httpOrgList(),
        getTicketsChannelConfig({data: {}}),
        getTicketsInternalConfig({data: {}}),
        getTicketsExposureConfig({data: {}}),
        getEnums('plus-crm', 'com.shj.saas.plus.crm.domain.tickets.enums.IssueStatusEnum'),
        getEnums('plus-crm', 'com.shj.saas.plus.crm.domain.tickets.enums.OrderIssueLevelEnum'),
        getEnums('plus-crm', 'com.shj.saas.plus.crm.domain.tickets.enums.IssueCommentStatusEnum'),
      ]).then(
        (resp) => {
          const listObj = {
            companyList: [...resp[0]],
            channelConfig: convertListToTree(resp[1],{pid: 'parentId'}) ,
            internalConfig:  convertListToTree(resp[2],{pid: 'parentId'}),
            exposureConfig: convertListToTree(resp[3],{pid: 'parentId'}),
            issueStatusEnum: resp[4],
            orderIssueLevelEnum: resp[5],
            issueCommentStatusEnum: resp[6],
          };
          resolve(listObj);
        },
      );
    });
  };
  const onExport = useCallback((record: any) => {
    const searchData_ = listRef.current.getSearch().getFieldsValue();
    const newObj = {...filterSerchData({...searchData_}, ['createDate', 'disposeDate', 'commentSendDate'])};
    if (newObj.classifyId) {
      newObj.classifyId = newObj.classifyId[newObj.classifyId.length - 1];
    }

    let params = '';
    Object.keys(newObj).map((val) => {
      if (newObj[val]) params += val + '=' + newObj[val] + '&';
    });
    if (params) {
      params = '?' + params.slice(0, params.length - 1);
    }

    message.loading({content: '导出中'});
    setExportLoading(true);
    // api
    //   .get(APIS.exportWorkerOrder + params, {
    //     responseType: 'arraybuffer',
    //   })
    //   .then((res: any) => {
    //     setExportLoading(false);
    //     if (res.status && res.status === 200) {
    //       exportFile({ response: res, data: res.data });
    //       message.success('下载完成');
    //       // message.destroy();
    //     } else {
    //       message.error('下载失败');
    //       // message.destroy();
    //     }
    //   })
    //   .catch(() => {
    //     setExportLoading(false);
    //     // message.destroy();
    //   });
  }, []);

  // 刷新
  const reload = () => {
    const {
      current: {reload},
    } = listRef;
    reload();
  };

  // 新建 or 编辑问题
  const addMatter = (record: any) => {
    // setState({open: true, data: {issueId: record.id, isEdited: record.isEdited}})
    setOpenMatterEditModal(true)
    setChooseRecord(record);
  };

  const onClassifySelect = (value: any, node: any, extra: any) => {
    if (!(!node.children || node.children?.length == 0)) {
      listRef.current.resetFields(['classifyId']);
    }
  };

  const extension = {
    request: {fetchList, getSelection},
    events: {onExport, addMatter, onClassifySelect},
    auth: authDict,
    status: {
      exportLoading
    },
    customRender: {
      codeRender(text: any, record: any) {
        return (<span
          onClick={() => {
            navigate(
              '/issues/matterList/detail/' + record.id
            );
          }}
          style={{ color: '#1677FF', cursor: 'pointer' }}
        >
          {text}
        </span>)
      },
      actionTool(text: any, record: any) {
        const postCode = ''//getNowUserInfo('postCode');

        // isCreatePerson  创建人
        // isCopyPerson 抄送人
        // isChargePerson  责任人
        // isDisposePerson  处理人
        // 未受理:1
        // 已受理:2
        // 处理中:4
        // 已处理:5
        // 已退回:3
        // 回访中:7
        // 草稿:0
        // 已归档:6

        // 未受理:1
        // isCreatePerson  创建人    催办、罚单
        // isDisposePerson  处理人   受理、退回
        // isChargePerson  责任人   受理、退回
        // isCopyPerson 抄送人   受理、退回

        // 已退回:3
        // isCreatePerson  创建人    编辑、罚单
        // isDisposePerson  处理人
        // isChargePerson  责任人
        // isCopyPerson 抄送人

        // 已归档:6
        // isCreatePerson  创建人    罚单
        // isDisposePerson  处理人
        // isChargePerson  责任人
        // isCopyPerson 抄送人

        // 处理中:4
        // isCreatePerson  创建人    催办、罚单
        // isDisposePerson  处理人
        // isChargePerson  责任人
        // isCopyPerson 抄送人

        // 已处理:5
        // isCreatePerson  创建人    重新打开、罚单
        // isDisposePerson  处理人
        // isChargePerson  责任人
        // isCopyPerson 抄送人

        // 回访中:7
        // isCreatePerson  创建人    编辑、罚单
        // isDisposePerson  处理人
        // isChargePerson  责任人
        // isCopyPerson 抄送人

        // 已受理:2
        // isCreatePerson  创建人    催办、罚单
        // isDisposePerson  处理人
        // isChargePerson  责任人
        // isCopyPerson 抄送人

        // 草稿:0
        // isCreatePerson  创建人    编辑
        // isDisposePerson  处理人
        // isChargePerson  责任人
        // isCopyPerson 抄送人

        return <STableActions>
          {record.status == 1 && (
              <SActionBtn
                  auth={'matterListEdit'}
                  onClick={() => {
                    setOpenMatterEditModal(true)
                    setChooseRecord({ ...record, isEdited: true });
                  }}
              >
                编辑
              </SActionBtn>
          )}

          {record.status != 3 && record.status != 9 && (
              <SActionBtn
                  auth={'pendingListAdd'}
                  onClick={() => {
                    modalAddWorkOrderFn({
                      fn: () => {
                        reload();
                      },
                      isEdited: false,
                      companyCode: record.companyId,
                      // workOrderObj: undefined,
                      issueId: record.id, //问题id
                    });
                  }}
              >
                建工单
              </SActionBtn>
          )}
          {record.status == 4 && record.commentResultDisplay == '未推送' && (
              <PushIssueComment auth={'matterListPushIssueComment'} issueId={record.id} fn={reload}></PushIssueComment> // 推送评价
          )}
          {record.status == 1 && (
              <SActionBtn
                  auth={'matterListReply'}
                  onClick={() => {
                    addCallBackIssueFn({
                      fn: () => {
                        const {
                          current: {reload},
                        } = listRef;
                        reload();
                      },
                      issueId: record.id, //问题id
                    });
                  }}
              >
                直接回复
              </SActionBtn>
          )}
        </STableActions>
      },
      checkPhone(text: any, record: any) {
        return (
            <CheckThePhone
                initValue={text}
                url={UrlConfig.PlusCrmWeb.TicketsIssueViewPhone}
                dataIndex={'feedbackPhone'}
                listRef={listRef}
                type={'GET'}
                data={{encodeValue: record.feedbackPhoneEncode}}
            />
        );
      },
    },
  };

  const configFun = () => {
    if (!!dataLevel && dataLevel != 'dataLevelGroup') {
      config['rowSelection'] = false;
      const _footer: any[] = [];
      config.footer.map((item: any) => {
        if (['导出', '批量修改处理人', '批量催办'].indexOf(item.label) == -1) {
          _footer.push(item);
        }
      });
      config.footer = _footer;
    }

    const _search = config.search.map((item: any) => {
      if (['createDate', 'lastDisposeDate', 'lastCallBackDate'].indexOf(item.name) != -1) {
        return {
          ...item,
          showTime: {
            defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')],
          },
        };
      } else {
        return item;
      }
    });
    config.search = _search;
    return config;
  };
  return (<>
      <SLowcodeList
          searchMode={'group'}
          config={{
            ...configFun(),
          }}
          ref={listRef}
          {...extension}
      />
        {/*<SDrawerOrModal*/}
        {/*    mode={'drawer'}*/}
        {/*    open={state.open}*/}
        {/*  onCancel={() => setState({open: false, record: {}})}*/}
        {/*>*/}
        {/*  <ModalAddMatterDom onClose={() => setState({open: false, record: {}})}*/}
        {/*                     record={state.record}*/}
        {/*                     {...state.data}*/}
        {/*                     fn={listRef.current?.reload}*/}
        {/*  />*/}
        {/*</SDrawerOrModal>*/}
        {openMatterEditModal && <ModalAddMatterFn
          open={openMatterEditModal}
          fn={() => { reload }}
          issueId={chooseRecord?.id}
          isEdited={chooseRecord?.isEdited}
          onClose={() => setOpenMatterEditModal(false)}
        />}
      </>
  );
}

export const PagePendingList = (props: any) => {
  return (
      <KeepAlive name={props.location.pathname} saveScrollPosition="screen" id={'keep' + location.pathname}>
        <PendingList {...props} />
      </KeepAlive>
  );
};

export default PagePendingList;
